import {
  FindFormReleaseByIdUseCase,
  FindLatestFormReleaseByFormIdUseCase,
  CreateFormReleaseUseCase,
  FORM_RELEASE_REPOSITORY,
  IFormReleaseRepository,
  FIND_FORM_RELEASE_BY_ID_USE_CASE,
  FIND_LATEST_FORM_RELEASE_BY_FORM_ID_USE_CASE,
  CREATE_FORM_RELEASE_USE_CASE,
} from '@module/form';

export const formReleaseUseCaseProviders = [
  {
    provide: FIND_FORM_RELEASE_BY_ID_USE_CASE,
    useFactory: (FormReleaseRepository: IFormReleaseRepository) => {
      return new FindFormReleaseByIdUseCase(FormReleaseRepository);
    },
    inject: [FORM_RELEASE_REPOSITORY],
  },
  {
    provide: FIND_LATEST_FORM_RELEASE_BY_FORM_ID_USE_CASE,
    useFactory: (FormReleaseRepository: IFormReleaseRepository) => {
      return new FindLatestFormReleaseByFormIdUseCase(FormReleaseRepository);
    },
    inject: [FORM_RELEASE_REPOSITORY],
  },
  {
    provide: CREATE_FORM_RELEASE_USE_CASE,
    useFactory: (FormReleaseRepository: IFormReleaseRepository) => {
      return new CreateFormReleaseUseCase(FormReleaseRepository);
    },
    inject: [FORM_RELEASE_REPOSITORY],
  },
];
